import {useMutation} from '@tanstack/react-query';
import {queryClient} from 'infra/libs/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {APIError} from 'data/errors/api-error';
import {HttpStatusCode} from 'data/protocols/http/http-client';
import {translations} from 'presentation/translations-new';
import {postRefundBankData} from '../../services/postRefundBankData';
import {PostBeneficiaryBankDataMutationProps} from './types';
import {useGetProgressQuery} from '../useGetProgressQuery';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {FeaturesEnum} from 'presentation/constants';

import {useRegistrationUpdateStatusStore} from 'presentation/pages/private/store/useRegistrationUpdateStatusStore';

const {errorAlert} = translations['pt-br'].privateFlow.profile.changeData;

export function usePostBeneficiaryBankDataMutation({
	handleChangeForm,
	setErrorMessage,
}: PostBeneficiaryBankDataMutationProps) {
	const {refetch} = useGetProgressQuery();
	const {setNeedsUpdate} = useRegistrationUpdateStatusStore();
	const {isEnabled: isNewProfileFeatureFlagEnabled} = useFeatureFlag(
		FeaturesEnum.ADD__PORTAL_FEATURE_NEW_PROFILE,
	);

	return useMutation({
		mutationFn: postRefundBankData,
		onSuccess: data => {
			queryClient.setQueryData([QUERY_KEYS.BENEFICIARY_BANK_DATA], data);

			if (isNewProfileFeatureFlagEnabled) {
				refetch();
			}

			handleChangeForm();
			queryClient.setQueryData([QUERY_KEYS.REGISTRATION_UPDATE_STATUS], {
				necessitaAtualizacao: false,
			});
			setNeedsUpdate(false);
		},
		onError: err => {
			if (err instanceof APIError && err.statusCode === HttpStatusCode.preconditionFailed) {
				setErrorMessage(err?.message);

				return;
			}
			setErrorMessage(errorAlert);
		},
	});
}
